import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum SalesInvoiceStatusId {
  PAID = 'paid',
  OVERDUE = 'overdue',
  UNPAID = 'unpaid',
}

export class SalesInvoiceStatus extends Codebook<SalesInvoiceStatusId> {
  static readonly PAID = new SalesInvoiceStatus(
    SalesInvoiceStatusId.PAID,
    () => $t('Paid'),
    Color.POSITIVE,
  )

  static readonly OVERDUE = new SalesInvoiceStatus(
    SalesInvoiceStatusId.OVERDUE,
    () => $t('Overdue'),
    Color.NEGATIVE,
  )

  static readonly UNPAID = new SalesInvoiceStatus(
    SalesInvoiceStatusId.UNPAID,
    () => $t('Unpaid'),
    Color.WARNING,
  )

  private constructor(
    id: SalesInvoiceStatusId,
    public readonly name: () => string,
    public readonly color: Color.POSITIVE | Color.NEGATIVE | Color.WARNING,
  ) {
    super(id)
  }
}
